import api from '../../../services/service_pos'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      bill_data: [],
      host_list: [],
      host: '',
      branch: 0,
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  created () {
    this.checkUser()
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.bill_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    CheckSearch () {
      if (this.search === '') {
        this.onChange(1)
        this.getBillAll()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getBillAll () {
      this.$store.commit('Loading')
      var obj = {
        'host_code': this.host.host_code,
        'keyword': this.search
      }
      api.billList(
        this.branch.dyn_address + '/',
        obj,
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        result => {
          if (result.response === 'success') {
            this.bill_data = []
            result.data.forEach(val => {
              if (val['holding_status'] === 0 && val['is_cancel'] === 0) {
                this.bill_data.push(val)
              }
            })
          } else {
            this.alert_msg('warning', 'เปิดการขายไม่ได้', result.message)
          }
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    cancelBill (data) {
      $('#ToolModal').modal('hide')
      Swal.fire({
        title: 'ยกเลิกบิล',
        text: 'ท่านต้องการยกเลิกบิลขายเลขที่ ' + data.doc_no + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ไม่ลบ'
      }).then((res) => {
        if (res.value) {
          this.$store.commit('Loading')
          var obj = {
            'doc_no': data.doc_no
          }
          api.cancelBill(
            this.branch.dyn_address + '/',
            obj,
            {
              headers: {
                'Access-Token': this.branch.access_token
              }
            },
            result => {
              if (result.response === 'success') {
                this.alert_msg('success', 'ยกเลิกบิล', 'ยกเลิกบิลเรียบร้อย')
                this.search = ''
              } else {
                this.alert_msg('warning', 'ยกเลิกบิล', 'ยกเลิกบิลไม่สมบูรณ์')
              }
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
              this.$store.commit('Loading')
            },
            error => {
              $('#ToolModal').modal('show')
              this.$store.commit('Loading')
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        } else {
          $('#ToolModal').modal('show')
        }
      })
    },
    getHost () {
      api.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getHost()
    this.getBranch()
    setTimeout(() => {
      this.search = ''
      this.branch = this.$store.state.branch_list[0]
      this.getBillAll()
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/bill_list.js